import { render, staticRenderFns } from "./vsts-integration-blocked-icon.component.vue?vue&type=template&id=091a4bec&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports